import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: '/crm',
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: {name: 'residentials'},
        },
        {
            path: '/auth',
            name: 'auth',
            component: () => import('./pages/Auth'),
            meta: {
                service: true,
            },
        },
        {
            path: '/promo/:id',
            name: 'promo-edit',
            component: () => import('./pages/PromoEdit.vue'),
        },
        {
            path: '/promo/',
            name: 'promo',
            component: () => import('./pages/Promo.vue'),
        },
        {
            path: '/banks/:id',
            name: 'bank-edit',
            component: () => import('./pages/BankEdit.vue'),
        },
        {
            path: '/banks',
            name: 'banks',
            component: () => import('./pages/Banks.vue'),
        },
        {
            path: '/developers/:id',
            name: 'developer-edit',
            component: () => import('./pages/DeveloperEdit.vue'),
        },
        {
            path: '/developers',
            name: 'developers',
            component: () => import('./pages/Developers.vue'),
        },
        {
            path: '/residentials/:id',
            name: 'residential-edit',
            component: () => import('./pages/ResidentialEdit.vue'),
        },
        {
            path: '/residentials',
            name: 'residentials',
            component: () => import('./pages/Residentials.vue'),
        },
        {
            path: '/advantage-objects/:id',
            name: 'advantage-object-edit',
            component: () => import('./pages/AdvantagesObjectEdit.vue'),
        },
        {
            path: '/advantage-objects',
            name: 'advantage-objects',
            component: () => import('./pages/AdvantagesObject.vue'),
        },
        {
            path: '/advantage-companies/:id',
            name: 'advantages-company-edit',
            component: () => import('./pages/AdvantagesCompanyEdit.vue'),
        },
        {
            path: '/advantage-companies',
            name: 'advantage-companies',
            component: () => import('./pages/AdvantagesCompany.vue'),
        },
        {
            path: '/repairs',
            name: 'repairs',
            component: () => import('./pages/Repairs.vue'),
        },
        {
            path: '/repairs/:id',
            name: 'repair-edit',
            component: () => import('./pages/RepairEdit.vue'),
        },
        {
            path: '/posts',
            name: 'posts',
            component: () => import('./pages/Posts.vue'),
        },
        {
            path: '/posts/:id',
            name: 'post-edit',
            component: () => import('./pages/PostEdit.vue'),
        },
        {
            path: '/digital',
            name: 'digital',
            component: () => import('./pages/Digital.vue'),
        },
        {
            path: '/digital/:id',
            name: 'digital-edit',
            component: () => import('./pages/DigitalCase.vue'),
        },
        {
            path: '/districts',
            name: 'districts',
            component: () => import('./pages/Districts.vue'),
        },
        {
            path: '/districts/:id',
            name: 'district-edit',
            component: () => import('./pages/DistrictEdit.vue'),
        },
        {
            path: '/city',
            name: 'city-edit',
            component: () => import('./pages/CityEdit.vue'),
        },
        {
            path: '*',
            name: 'other',
            redirect: {name: 'residentials'},
        },
    ],
});
